//main.js
console.log("main.js loaded");
document.addEventListener('DOMContentLoaded', function () {
    const accordionTrigger = document.querySelector('[data-accordion-trigger="accordion-cart-notes"]');
    const accordionBody = document.getElementById('accordion-cart-notes');
  
    if (accordionTrigger && accordionBody) {
      accordionTrigger.addEventListener('click', function () {
        const isExpanded = accordionTrigger.getAttribute('aria-expanded') === 'true';
  
        accordionTrigger.setAttribute('aria-expanded', !isExpanded);
        accordionBody.style.display = isExpanded ? 'block' : 'none';
      });
  
      accordionTrigger.setAttribute('aria-expanded', 'true');
      accordionBody.style.display = 'none';
    }
  });
  